var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPickUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 48,
    viewBox: "0 0 36 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8 26.9156C12.6938 26.9156 11.6719 26.3906 11.0719 25.4156L9 21.3844V28.725L13.125 32.2594C14.1938 33.1782 14.9062 34.4438 15.1416 35.6672L16.4653 44.3391C16.7344 45.9685 15.6328 47.5149 13.9922 47.7844C11.4956 48.1941 10.6406 45.8508 10.5469 45.3235L9.22313 36.6516L2.09812 30.5456C0.773438 29.3981 0 27.7453 0 25.9875V16.4156C0 13.9303 2.01469 11.9156 4.5 11.9156H7.19531C9.42188 11.9156 11.4656 13.2281 12.4969 15.2063L15.6187 21H18V26.9156H13.8ZM3 47.9063C1.33594 47.9063 0 46.6547 0 44.9907V32.7544C0.0172253 32.7683 0.419443 33.1157 1.016 33.631C2.43245 34.8545 4.94452 37.0244 6 37.9228V44.911C6 46.575 4.66406 47.9063 3 47.9063Z",
    fill: "#E34B31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.41563C3 2.01562 5.01562 0 7.5 0C9.98438 0 12 2.0156 12 4.4156C12 6.98435 9.98438 8.9156 7.5 8.9156C5.01562 8.9156 3 6.98435 3 4.41563ZM21 8.9156H33C34.65 8.9156 36 10.35 36 11.9156V23.8314C36 25.4814 34.65 26.8314 33 26.8314L18 26.8312V11.9156C18 10.2656 19.35 8.9156 21 8.9156Z",
    fill: "#E34B31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickUp);
export default __webpack_public_path__ + "static/media/pick-up.e46ce453b906ef04442b6338400b22e1.svg";
export { ForwardRef as ReactComponent };